import api from "./axios";

// Tüm Ödemeleri Getir
export const getAllPayments = async () => {
    try {
        const response = await api.post("api/v1/Payment/all");
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Ödeme listesi getirilemedi!" };
    }
};

// Ödeme Detayı Getir
export const getPaymentDetail = async (transactionId) => {
    try {
        const response = await api.post("api/v1/Payment/detail", { transactionId });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Ödeme detayı alınamadı!" };
    }
};

// Ödeme Özeti Getir
export const getPaymentSummary = async () => {
    try {
        const response = await api.post("api/v1/Payment/summary");
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Ödeme özeti alınamadı!" };
    }
};

// Ödeme Onayla
export const approvePayment = async (data) => {
    // data: { transactionId, comment, file }
    const formData = new FormData();
    formData.append("TransactionId", data.transactionId); // Backend case-sensitive olabilir, user TransactionId dedi
    if (data.comment) formData.append("Comment", data.comment);
    if (data.file) formData.append("File", data.file);

    try {
        const response = await api.post("api/v1/Payment/approve", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Ödeme onaylanamadı!" };
    }
};

// Ödeme Reddet
export const rejectPayment = async (data) => {
    const formData = new FormData();
    formData.append("TransactionId", data.transactionId);
    if (data.comment) formData.append("Comment", data.comment);
    if (data.file) formData.append("File", data.file);

    try {
        const response = await api.post("api/v1/Payment/reject", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Ödeme reddedilemedi!" };
    }
};
